import { getShipmentDefaultFilters } from '@/views/pages/Savers/shipment/constants';

import { DEFAULT_STORE_OBJECT } from '../constants';
import SaversTypes from './SaversTypes';

const initialState = {
  locID: { ...DEFAULT_STORE_OBJECT, data: [] },
  loggedInUser: { ...DEFAULT_STORE_OBJECT, data: [] },
  rateList: { ...DEFAULT_STORE_OBJECT, data: [] },
  reqID: { ...DEFAULT_STORE_OBJECT, data: [] },
  selectedRate: { ...DEFAULT_STORE_OBJECT, data: [] },
  selectedRateResult: { ...DEFAULT_STORE_OBJECT, data: [] },
  selectedRateResultIndex: { ...DEFAULT_STORE_OBJECT, data: [] },
  shipmentFilters: getShipmentDefaultFilters(),
  shipmentList: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
    isFirstTime: true,
    isReset: false,
    totalPageCount: 0,
  },
  supplierList: { ...DEFAULT_STORE_OBJECT, data: [] },
  trailerID: { ...DEFAULT_STORE_OBJECT, data: [] },
};

// biome-ignore lint/style/useDefaultParameterLast: can't be modified
const SaversReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SaversTypes.SET_SELECTED_TRAILER_REQUEST: {
      return {
        ...state,
        reqID: {
          ...DEFAULT_STORE_OBJECT,
          data: payload,
          progressing: true,
        },
      };
    }
    case SaversTypes.SET_SELECTED_LOCATION_REQUEST: {
      return {
        ...state,
        locID: {
          ...DEFAULT_STORE_OBJECT,
          data: payload,
          progressing: true,
        },
      };
    }
    case SaversTypes.SET_SELECTED_TRAILER_ID: {
      return {
        ...state,
        trailerID: {
          ...DEFAULT_STORE_OBJECT,
          data: payload,
          progressing: true,
        },
      };
    }
    case SaversTypes.SET_RATE_LIST: {
      return {
        ...state,
        rateList: {
          ...DEFAULT_STORE_OBJECT,
          data: payload,
          progressing: true,
        },
      };
    }
    case SaversTypes.SET_SELECTED_RATE: {
      return {
        ...state,
        selectedRate: {
          ...DEFAULT_STORE_OBJECT,
          data: payload,
          progressing: true,
        },
      };
    }
    case SaversTypes.SET_SELECTED_RATE_RESULT: {
      return {
        ...state,
        selectedRateResult: {
          ...DEFAULT_STORE_OBJECT,
          data: payload,
          progressing: true,
        },
      };
    }
    case SaversTypes.SET_SELECTED_RATE_RESULT_INDEX: {
      return {
        ...state,
        selectedRateResultIndex: {
          ...DEFAULT_STORE_OBJECT,
          data: payload,
          progressing: true,
        },
      };
    }

    case SaversTypes.SET_LOGGEDIN_USER_TYPE: {
      return {
        ...state,
        loggedInUser: {
          ...DEFAULT_STORE_OBJECT,
          data: payload,
          progressing: true,
        },
      };
    }
    case SaversTypes.SET_SAVERS_SUPPLIER: {
      return {
        ...state,
        supplierList: {
          ...DEFAULT_STORE_OBJECT,
          data: payload,
          progressing: true,
        },
      };
    }

    case SaversTypes.SET_SHIPMENT_LIST: {
      return {
        ...state,
        shipmentList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.shipmentList,
          ...payload,
        },
      };
    }

    case SaversTypes.SET_SHIPMENT_FILTERS: {
      return {
        ...state,
        shipmentFilters: {
          ...state.shipmentFilters,
          ...payload,
        },
      };
    }

    case SaversTypes.GET_SHIPMENT_LIST_PROGRESS: {
      return {
        ...state,
        shipmentList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.shipmentList,
          isFirstTime: false,
          progressing: true,
          ...payload,
        },
      };
    }
    case SaversTypes.GET_SHIPMENT_LIST_SUCCESS: {
      return {
        ...state,
        shipmentList: {
          ...DEFAULT_STORE_OBJECT,
          data: state.shipmentList.isReset
            ? payload.data.trailerShipmentDataResult.map((element) => ({
                ...element,
              }))
            : [
                ...state.shipmentList.data,
                ...payload.data.trailerShipmentDataResult.map((element) => ({
                  ...element,
                })),
              ],
          isFirstTime: false,
          success: true,
          totalPageCount: payload.data.trailerShipmentFooterResult.shipmentCount,
        },
      };
    }

    default:
      return state;
  }
};

export default SaversReducer;
